import { useState } from 'react'
import { OptionProps } from '../NavigationSlider'

type UseNavigationSliderProps = {
  options: OptionProps[]
}

const useNavigationSlider = ({ options }: UseNavigationSliderProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const onNextClickHandler = () => {
    const totalPages = options.length

    const newIndex =
      currentIndex === totalPages - 1 ? currentIndex : currentIndex + 1

    setCurrentIndex(newIndex)
  }

  const onPrevClickHandler = () => {
    const newIndex = currentIndex === 0 ? currentIndex : currentIndex - 1

    setCurrentIndex(newIndex)
  }

  const getDisabledArrow = (): 'prev' | 'next' | undefined => {
    if (currentIndex === 0) {
      return 'prev'
    }
    if (currentIndex === options.length - 1) {
      return 'next'
    }

    return undefined
  }

  const currentValue = options[currentIndex]?.value || ''

  return {
    onNextClick: onNextClickHandler,
    onPrevClick: onPrevClickHandler,
    disabledArrow: getDisabledArrow(),
    currentIndex,
    currentValue
  }
}

export default useNavigationSlider
